import * as React from 'react'
import { routeProvider } from '$utils/routeProvider'

export const NotFound: React.SFC = () => {
  window.location.href = routeProvider.notFount
  return null
}



// WEBPACK FOOTER //
// ./src/views/components/NotFound/NotFound.tsx